
export enum PaymentTier {
  /** Free Tier */
  Tier0 = "tier0",
  /** Middle Tier */
  Tier1 = "tier1",
  /** Full Tier */
  Tier2 = "tier2",
}

export enum PaymentRecordStatus {
  /** Payment is in progress or awaiting confirmation */
  Pending = "pending",
  /** Payment has been successfully completed */
  Paid = "paid",
  /** Payment has failed */
  Failed = "failed",
}

export const PAYMENT_TIER_TOKEN_LIMITS: Record<PaymentTier, number> = {
  [PaymentTier.Tier0]: 500000,
  [PaymentTier.Tier1]: 500000,
  [PaymentTier.Tier2]: 500000,
};

export const PAYMENT_TIER_WORD_LIMITS: Record<PaymentTier, number> = {
  [PaymentTier.Tier0]: PAYMENT_TIER_TOKEN_LIMITS[PaymentTier.Tier0] * 0.8,
  [PaymentTier.Tier1]: PAYMENT_TIER_TOKEN_LIMITS[PaymentTier.Tier1] * 0.8,
  [PaymentTier.Tier2]: PAYMENT_TIER_TOKEN_LIMITS[PaymentTier.Tier2] * 0.8,
};

export type PaymentTierInfo = {
  title: string;
  description: string;
  /** the cost displayed to the user */
  cost: string;
  /** the numeric cost of the tier in cents */
  costValueInCents: number;
  additionalCost: string;
  maxWordCount: string;
  reports: string[];
  cta: string;
  costPerAdditionalDraft: string;
};

export const PAYMENT_TIER_INFO: Record<PaymentTier, PaymentTierInfo> = {
  [PaymentTier.Tier0]: {
    title: "Blueprint",
    description:
      "Story Stream 'Blueprint Editorial Review' - Ideal for initial feedback on shorter works and a quick overview of your manuscript's strengths. This free analysis includes Plot Coherence, Thematic Analysis, Pacing Analysis, and Sequel Potential.",
    cost: "Free",
    costValueInCents: 0,
    additionalCost: "$30",
    maxWordCount: PAYMENT_TIER_WORD_LIMITS[PaymentTier.Tier0].toLocaleString(),
    reports: [
      "Plot Coherence",
      "Thematic Analysis",
      "Pacing Analysis",
      "Sequel Potential",
    ],
    cta: "Get Started",
    costPerAdditionalDraft: "",
  },
  [PaymentTier.Tier1]: {
    title: "First Edition",
    description:
      "Story Stream 'First Edition Review' - Perfect for a thorough check of your core elements. This includes an Overall Summary,  Plot Coherence, Thematic Analysis, Pacing Analysis, Cultural Analysis, Protagonist Analysis, Language and Style, Author Intention Assessment, Sequel Potential, and Story Flow.",
    cost: "$199",
    costValueInCents: 19900,
    additionalCost: "$20",
    maxWordCount: PAYMENT_TIER_WORD_LIMITS[PaymentTier.Tier1].toLocaleString(),
    reports: [
      "Overall Summary",
      "Plot Coherence",
      "Thematic Analysis",
      "Pacing Analysis",
      "Cultural Analysis",
      "Protagonist Analysis",
      "Language and Style",
      "Author Intention Assessment",
      "Tropes and Cliches",
      "Sequel Potential",
      "Story Flow",
    ],
    cta: "Choose First Edition",
    costPerAdditionalDraft: "",
  },
  [PaymentTier.Tier2]: {
    title: "Masterpiece",
    description:
      "Story Stream 'Masterpiece Review' - This package is suitable for authors looking to publish their work. It includes everything from the Focused Review as well as your most detailed analysis with all reports included. Receive 20 reports, a Comprehensive Editorial Overview, a Roadmap to Published, Story Flow analysis and The Character Bundle. ",
    cost: "$399",
    costValueInCents: 39900,
    additionalCost: "All reports included",
    maxWordCount: PAYMENT_TIER_WORD_LIMITS[PaymentTier.Tier2].toLocaleString(),
    reports: [
      "Complete Analysis (17 total reports)",
      "Comprehensive Editorial Overview",
      "Roadmap to Published ",
      "Story Flow",
      "The Character Bundle",
    ],
    cta: "Choose Masterpiece",
    costPerAdditionalDraft: "",
  },
};